import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";
import { logout } from "../../common/helpers/auth";

export class SwapPool extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      loaded2: false,
      loaded3: false,
      serviceList: "",
      serviceSelected: false,
      selectedService: "",
      selectedServiceId: "",
      selectedServiceTitle: "",
      selectedServiceDetails: "",
      selectedServicePrice: "",
      selectedServiceDifficultyLevel: "",
      swapList: [],
      swapSelected: false,
      selectedSwap: "",
      selectedSwapFirstName: "",
      selectedSwapSurname: "",
      selectedSwapStartTime: "",
      selectedSwapEndTime: "",
      selectedSwapEmail: "",
      selectedSwapTelephone: "",
      selectedSwapId: "",
      selectedSwapUserId: "",
      selectedSwapLastUpdatedDateTime: "",
      selectedSwapOrigBookId: "",
      selectedSwapSetId: "",
      selectedSwapDisplayDate: "",
      clientList: [],
      clientOptions: [],
      selectedClient: "",
      clientPaid: false,
      availableSetList: [],
      availableSetOptions: [],
      selectedAvailableSet: "",
    };
  }

  componentDidMount = () => {
    if (localStorage.getItem("roleType") === "30") {
      logout();
      localStorage.clear();
      window.location = "#/";
      window.location.reload();
    }
    this.getServices();
  };

  getClients = async () => {
    this.setState({ loaded3: false });

    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");
    userRequest.id = localStorage.getItem("userId");
    userRequest.level = [this.state.selectedServiceDifficultyLevel];

    await api("userApiV1UserListByLevel", userRequest).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.users)) {
          res.data.users.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let userResponse =
          Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState(
            {
              clientList: userResponse.users,
            },
            () => {
              this.clientsToOptions();
            }
          );
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Clients could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("userApiV1UserListByLevel has failed");
      }
    });
  };

  clientsToOptions = () => {
    let clientArray = [];

    if (Array.isArray(this.state.clientList)) {
      this.state.clientList.forEach((e) => {
        clientArray.push({
          label: e.firstName + " " + e.surname,
          value: e.id,
        });
      });
    }

    this.setState({ clientOptions: clientArray, loaded3: true });
  };

  getServices = async () => {
    this.setState({ loaded: false });

    let serviceRequest = new Belfastpilatesappspotcom.ServiceRequest();
    serviceRequest.codeTag = localStorage.getItem("globalBid");

    await api("serviceApiV1ServiceGetByCodeTag", serviceRequest).then((res) => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let serviceResponse =
          Belfastpilatesappspotcom.ServiceResponse.constructFromObject(
            res.data
          );
        console.log(serviceResponse);

        if (serviceResponse.errorCode === 0) {
          this.setState({
            serviceList: serviceResponse.serviceList,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Services could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("serviceApiV1ServiceGetByCodeTag has failed");
      }
    });

    this.setState({ loaded: true });
  };

  getServiceAdvanced = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Intermediate/Advanced") {
          console.log(e);
          this.setState(
            {
              swapSelected: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
            },
            () => {
              this.getClients();
              this.getServiceSwaps();
            }
          );
        }
      });
    }
  };

  getServiceIntermediate = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Progressive/Intermediate") {
          console.log(e);
          this.setState(
            {
              swapSelected: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
            },
            () => {
              this.getClients();
              this.getServiceSwaps();
            }
          );
        }
      });
    }
  };

  getServiceBeginner = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Beginner/Progressive") {
          console.log(e);
          this.setState(
            {
              swapSelected: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
            },
            () => {
              this.getClients();
              this.getServiceSwaps();
            }
          );
        }
      });
    }
  };

  getServiceReformer = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Reformer") {
          console.log(e);
          this.setState(
            {
              swapSelected: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
            },
            () => {
              this.getClients();
              this.getServiceSwaps();
            }
          );
        }
      });
    }
  };

  getServiceMumAndBaby = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Mum and Baby") {
          console.log(e);
          this.setState(
            {
              swapSelected: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
            },
            () => {
              this.getClients();
              this.getServiceSwaps();
            }
          );
        }
      });
    }
  };

  getServiceAntenatal = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Antenatal") {
          console.log(e);
          this.setState(
            {
              swapSelected: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
            },
            () => {
              this.getClients();
              this.getServiceSwaps();
            }
          );
        }
      });
    }
  };

  getServiceKids = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Kids") {
          console.log(e);
          this.setState(
            {
              swapSelected: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
            },
            () => {
              this.getClients();
              this.getServiceSwaps();
            }
          );
        }
      });
    }
  };

  getServiceMatureMovers = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Mature Movers") {
          console.log(e);
          this.setState(
            {
              swapSelected: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
            },
            () => {
              this.getClients();
              this.getServiceSwaps();
            }
          );
        }
      });
    }
  };

  getServiceSwaps = async () => {
    this.setState({ loaded2: false });

    let swapRequest = new Belfastpilatesappspotcom.SwapRequest();
    swapRequest.codeTag = localStorage.getItem("globalBid");
    swapRequest.userId = localStorage.getItem("userId");
    swapRequest.level = this.state.selectedServiceDifficultyLevel;
    swapRequest.availableForSwap = true;

    await api("swapApiV1SwapGetByLevelAndAvailableForSwap", swapRequest).then(
      (res) => {
        if (res.data) {
          if (Array.isArray(res.data.swapList)) {
            res.data.swapList.forEach((e) => {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            });
          }

          let swapResponse =
            Belfastpilatesappspotcom.SwapResponse.constructFromObject(res.data);
          console.log(swapResponse);

          if (swapResponse.errorCode === 0) {
            this.setState(
              {
                swapList: swapResponse.swapList,
              },
              () => {
                this.swapsToUI();
              }
            );
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail:
                "Swaps could not be retrieved, please refresh and try again",
              life: 3000,
            });
          }
        } else {
          console.log("swapApiV1SwapGetByLevelAndAvailableForSwap has failed");
        }
      }
    );

    this.setState({ loaded2: true });
  };

  swapsToUI = () => {
    let swapArray = [];
    let i = 0;

    let noSwaps = [
      <div key={i} className="ui-g-12">
        <div className="card">
          <h1>&nbsp;</h1>
          <h1>No Swaps</h1>
          <h1>&nbsp;</h1>
        </div>
      </div>,
    ];

    if (Array.isArray(this.state.swapList)) {
      this.state.swapList.forEach((e) => {
        swapArray[i] = (
          <div key={i} className="ui-g-12">
            <div
              id={i}
              className="card"
              onMouseOver={(f) => {
                f.currentTarget.style.boxShadow = "5px 5px 10px grey";
              }}
              onMouseOut={(f) => {
                f.currentTarget.style.boxShadow = "";
              }}
              onClick={(g) => {
                let element = document.getElementById(
                  localStorage.getItem("swapPoolLastSelectedCardId")
                );
                if (element) {
                  element.style.backgroundColor = "white";
                }
                g.currentTarget.style.backgroundColor = "#F44336";
                localStorage.setItem(
                  "swapPoolLastSelectedCardId",
                  g.currentTarget.id
                );

                this.setState(
                  {
                    swapSelected: true,
                    selectedSwap: e,
                    selectedSwapStartTime: e.startTime,
                    selectedSwapEndTime: e.endTime,
                    selectedSwapId: e.id,
                    selectedSwapLastUpdatedDateTime: e.lastUpdatedDateTime,
                    selectedSwapOrigBookId: e.origBookId,
                    selectedSwapSetId: e.setId,
                    selectedSwapDisplayDate: e.sessionDateToDisplay,
                  },
                  () => {
                    if (e.userDetails) {
                      this.setState({
                        selectedSwapFirstName: e.userDetails.firstName,
                        selectedSwapSurname: e.userDetails.surname,
                        selectedSwapEmail: e.userDetails.email,
                        selectedSwapTelephone: e.userDetails.contactTelephone,
                        selectedSwapUserId: e.userDetails.userId,
                      });
                    }
                    console.log(this.state.selectedSwap);
                  }
                );
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <h1>{this.state.selectedServiceDifficultyLevel}</h1>
              <h1>{e.sessionDateToDisplay}</h1>
              <h2>{e.startTime + " - " + e.endTime}</h2>
              <h1>{e.userDetails.firstName + " " + e.userDetails.surname}</h1>
            </div>
          </div>
        );
        i++;
      });
    }

    if (!swapArray || swapArray.length === 0) {
      return noSwaps;
    }

    return swapArray;
  };

  getAvailableSetsForSwap = async () => {
    this.setState({ loaded3: false });

    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.userId = this.state.selectedClient;
    setRequest.bookIdentifier = "BOOK";

    await api("setApiV1SetsGetByUserIdAndSwapPaymentRequired", setRequest).then(
      (res) => {
        if (res.data) {
          let setResponse =
            Belfastpilatesappspotcom.SetResponse.constructFromObject(res.data);
          console.log(setResponse);

          if (setResponse.errorCode === 0) {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Sets successfully retrieved",
              life: 3000,
            });
            this.setState({ availableSetList: setResponse.setList }, () => {
              this.availableSetsForSwapToOptions();
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail:
                "Sets could not be retrieved, please refresh and try again",
              life: 3000,
            });
          }
        } else {
          console.log(
            "setApiV1SetsGetByUserIdAndSwapPaymentRequired has failed"
          );
        }
      }
    );

    this.setState({ loaded3: true });
  };

  availableSetsForSwapToOptions = () => {
    let availableSetArray = [];
    let i = 0;

    if (Array.isArray(this.state.availableSetList)) {
      this.state.availableSetList.forEach((e) => {
        //Monday
        let startDateMonday = "";
        let endDateMonday = "";
        //Tuesday
        let startDateTuesday = "";
        let endDateTuesday = "";
        //Wednesday
        let startDateWednesday = "";
        let endDateWednesday = "";
        //Thursday
        let startDateThursday = "";
        let endDateThursday = "";
        //Friday
        let startDateFriday = "";
        let endDateFriday = "";
        //Saturday
        let startDateSaturday = "";
        let endDateSaturday = "";
        //Sunday
        let startDateSunday = "";
        let endDateSunday = "";

        //Monday
        if (Array.isArray(e.mondayTime)) {
          startDateMonday = e.mondayTime[0];
          endDateMonday = e.mondayTime[1];
        }
        //Tuesday
        if (Array.isArray(e.tuesdayTime)) {
          startDateTuesday = e.tuesdayTime[0];
          endDateTuesday = e.tuesdayTime[1];
        }
        //Wednesday
        if (Array.isArray(e.wednesdayTime)) {
          startDateWednesday = e.wednesdayTime[0];
          endDateWednesday = e.wednesdayTime[1];
        }
        //Thursday
        if (Array.isArray(e.thursdayTime)) {
          startDateThursday = e.thursdayTime[0];
          endDateThursday = e.thursdayTime[1];
        }
        //Friday
        if (Array.isArray(e.fridayTime)) {
          startDateFriday = e.fridayTime[0];
          endDateFriday = e.fridayTime[1];
        }
        //Saturday
        if (Array.isArray(e.saturdayTime)) {
          startDateSaturday = e.saturdayTime[0];
          endDateSaturday = e.saturdayTime[1];
        }
        //Sunday
        if (Array.isArray(e.sundayTime)) {
          startDateSunday = e.sundayTime[0];
          endDateSunday = e.sundayTime[1];
        }

        availableSetArray[i] = {
          label:
            e.level +
            " - " +
            e.startDateDisplayString +
            // " - " +
            // (e.noOfBooks - e.bookList.length) +
            " - " +
            (startDateMonday + " " + endDateMonday) +
            (startDateTuesday + " " + endDateTuesday) +
            (startDateWednesday + " " + endDateWednesday) +
            (startDateThursday + " " + endDateThursday) +
            (startDateFriday + " " + endDateFriday) +
            (startDateSaturday + " " + endDateSaturday) +
            (startDateSunday + " " + endDateSunday),
          value: e.id,
        };
        i++;
      });
    }

    this.setState({ availableSetOptions: availableSetArray, loaded3: true });
  };

  updateSwap = async () => {
    if (!this.state.selectedClient) {
      this.growl.show({
        severity: "error",
        summary: "Missing Fields",
        detail: "Please select a client to swap with",
        life: 3000,
      });
    } else {
      this.setState({ loaded2: false });

      let swapRequest = new Belfastpilatesappspotcom.SwapRequest();
      swapRequest.codeTag = localStorage.getItem("globalBid");
      swapRequest.userId = this.state.selectedClient;
      swapRequest.id = this.state.selectedSwapId;
      swapRequest.origBookId = this.state.selectedSwapOrigBookId;
      swapRequest.setId = this.state.selectedAvailableSet;
      swapRequest.lastUpdatedDateTime =
        this.state.selectedSwapLastUpdatedDateTime;
      swapRequest.paymentReference = "PORTAL_PAYMENT";
      swapRequest.paid = this.state.clientPaid;

      await api("swapApiV1SwapUpdate", swapRequest).then((res) => {
        if (res.data) {
          let swapResponse =
            Belfastpilatesappspotcom.SwapResponse.constructFromObject(res.data);
          console.log(swapResponse);

          if (swapResponse.errorCode === 0) {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Client successfully swapped",
              life: 3000,
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Client could not be swapped",
              life: 3000,
            });
          }
        } else {
          console.log("swapApiV1SwapUpdate has failed");
        }
      });

      this.getServiceSwaps();
    }
  };

  render() {
    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={(el) => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <pr.Growl
          style={{ textAlign: "left" }}
          ref={(el) => (this.growl = el)}
        />
        <div className="ui-g-12">
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="red-btn"
              label="Intermediate/Advanced"
              onClick={() => {
                this.getServiceAdvanced();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="green-btn"
              label="Progressive/Intermediate"
              onClick={() => {
                this.getServiceIntermediate();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="indigo-btn"
              label="Beginner/Progressive"
              onClick={() => {
                this.getServiceBeginner();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="pink-btn"
              label="Reformer"
              onClick={() => {
                this.getServiceReformer();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="amber-btn"
              label="Mum and Baby"
              onClick={() => {
                this.getServiceMumAndBaby();
              }}
              style={{ color: "white", width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="orange-btn"
              label="Antenatal"
              onClick={() => {
                this.getServiceAntenatal();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="cyan-btn"
              label="Kids"
              onClick={() => {
                this.getServiceKids();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="violet-btn"
              label="Mature Movers"
              onClick={() => {
                this.getServiceMatureMovers();
              }}
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div className="ui-g-12">
          {!this.state.serviceSelected ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                {!this.state.swapSelected ? (
                  <label />
                ) : this.state.loaded3 ? (
                  <div className="ui-g-12 ui-md-12">
                    <div className="ui-g-12 ui-md-6">
                      <div className="ui-g-12">
                        <b>Current Holder: </b>
                        <label>
                          {this.state.selectedSwapFirstName +
                            " " +
                            this.state.selectedSwapSurname}
                        </label>
                      </div>
                      <div className="ui-g-12">
                        <b>Date: </b>
                        <label>{this.state.selectedSwapDisplayDate}</label>
                      </div>
                      <div className="ui-g-12">
                        <b>From: </b>
                        <label>{this.state.selectedSwapStartTime}</label>
                      </div>
                      <div className="ui-g-12">
                        <b>To: </b>
                        <label>{this.state.selectedSwapEndTime}</label>
                      </div>
                    </div>
                    <div className="ui-g-12 ui-md-6">
                      <div className="ui-g-12">
                        <b>Email: </b>
                        <label>{this.state.selectedSwapEmail}</label>
                      </div>
                      <div className="ui-g-12">
                        <b>Telephone: </b>
                        <label>{this.state.selectedSwapTelephone}</label>
                      </div>
                      <div className="ui-g-12">
                        <label>Assign to another client</label>
                        <br />
                        <pr.Dropdown
                          value={this.state.selectedClient || ""}
                          options={this.state.clientOptions}
                          onChange={(e) => {
                            this.setState({ selectedClient: e.value }, () => {
                              this.getAvailableSetsForSwap();
                            });
                          }}
                        />
                      </div>
                      <div className="ui-g-12">
                        <label>Pick Set</label>
                        <br />
                        {this.state.availableSetOptions &&
                        this.state.availableSetOptions.length ? (
                          <pr.Dropdown
                            value={this.state.selectedAvailableSet || ""}
                            options={this.state.availableSetOptions}
                            onChange={(e) => {
                              this.setState({ selectedAvailableSet: e.value });
                            }}
                          />
                        ) : (
                          <label>No sets to pick from</label>
                        )}
                      </div>
                      <div className="ui-g-12">
                        <b>Paid: </b>
                        <pr.Checkbox
                          onChange={(e) =>
                            this.setState({ clientPaid: e.checked })
                          }
                          checked={this.state.clientPaid}
                          style={{ align: "middle" }}
                        />
                      </div>
                    </div>
                    <div className="ui-g-12">
                      <pr.Button
                        label="Swap"
                        onClick={() => {
                          this.updateSwap();
                          this.setState({ swapSelected: false });
                        }}
                        style={{ float: "right" }}
                      />
                      <pr.Button
                        label="Cancel"
                        onClick={() => {
                          this.setState({ swapSelected: false });
                        }}
                        style={{ float: "right" }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="ui-g-12 ui-md-8">
                    <center>
                      <LoadScreen />
                    </center>
                  </div>
                )}
                {!this.state.loaded2 ? (
                  <div className="ui-g-12">
                    <center>
                      <LoadScreen />
                    </center>
                  </div>
                ) : (
                  <div className="ui-g-12">
                    <pr.DataTable
                      value={this.state.swapList}
                      selectionMode="single"
                      selection={this.state.selectedSwap}
                      onSelectionChange={(e) => {
                        this.setState(
                          {
                            swapSelected: true,
                            selectedSwap: e.data,
                            selectedSwapStartTime: e.data.startTime,
                            selectedSwapEndTime: e.data.endTime,
                            selectedSwapId: e.data.id,
                            selectedSwapLastUpdatedDateTime:
                              e.data.lastUpdatedDateTime,
                            selectedSwapOrigBookId: e.data.origBookId,
                            selectedSwapSetId: e.data.setId,
                            selectedSwapDisplayDate:
                              e.data.sessionDateToDisplay,
                          },
                          () => {
                            if (e.data.userDetails) {
                              this.setState({
                                selectedSwapFirstName:
                                  e.data.userDetails.firstName,
                                selectedSwapSurname: e.data.userDetails.surname,
                                selectedSwapEmail: e.data.userDetails.email,
                                selectedSwapTelephone:
                                  e.data.userDetails.contactTelephone,
                                selectedSwapUserId: e.data.userDetails.userId,
                              });
                            }
                            console.log(this.state.selectedSwap);
                          }
                        );
                      }}
                      header="Swaps"
                      footer=" "
                      autoLayout={true}
                      paginator={false}
                      alwaysShowPaginator={false}
                      scrollable={true}
                    >
                      <pr.Column
                        field="level"
                        header="Level"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="sessionDateToDisplay"
                        header="Session Date"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="startTime"
                        header="Start Time"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="endTime"
                        header="End Time"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="userDetails.firstName"
                        header="First Name"
                        body={(e) => {
                          if (e.userDetails) {
                            return e.userDetails.firstName;
                          }
                        }}
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="userDetails.surname"
                        header="Surname"
                        body={(e) => {
                          if (e.userDetails) {
                            return e.userDetails.surname;
                          }
                        }}
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                    </pr.DataTable>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SwapPool/SwapPool.js